import _defineProperty from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["styles", "widths", "tag"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { applyStylingHoc } from '../../lib/styling.js';
import { getColumnSizeClass } from '../../lib/utils.js';
import baseStyles from './Grid.scss';
var colWidths = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
export var Col = function Col(props) {
  var styles = props.styles,
      _props$widths = props.widths,
      widths = _props$widths === void 0 ? colWidths : _props$widths,
      _props$tag = props.tag,
      Tag = _props$tag === void 0 ? 'div' : _props$tag,
      attributes = _objectWithoutProperties(props, _excluded);

  var colClasses = [];
  widths && widths.forEach(function (colWidth, i) {
    // @ts-ignore: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Props'.
    var columnProp = props[colWidth]; // @ts-ignore: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type {...}

    delete attributes[colWidth];

    if (!columnProp && typeof columnProp !== 'string') {
      return;
    }

    var isXs = !i;

    if (typeof columnProp === 'object') {
      var _classNames;

      var colSizeInterfix = isXs ? '-' : "-".concat(colWidth, "-");
      var colClass = getColumnSizeClass(isXs, colWidth, columnProp.size, styles);
      colClasses.push(classNames((_classNames = {}, _defineProperty(_classNames, colClass, columnProp.size || columnProp.size === ''), _defineProperty(_classNames, styles["order".concat(colSizeInterfix).concat(columnProp.order)], columnProp.order || columnProp.order === 0), _defineProperty(_classNames, styles["offset".concat(colSizeInterfix).concat(columnProp.offset)], columnProp.offset || columnProp.offset === 0), _classNames)));
    } else {
      var _colClass = getColumnSizeClass(isXs, colWidth, columnProp, styles);

      colClasses.push(_colClass);
    }
  });

  if (!colClasses.length) {
    colClasses.push(styles['col']);
  }

  var classes = classNames(styles.root, colClasses);
  return React.createElement(Tag, _objectSpread(_objectSpread({}, attributes), {}, {
    className: classes
  }));
};
export default applyStylingHoc(baseStyles)(Col);